import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

const FormVote = ({ onSubmitVote, data, isLoading, isVoteSuccess, onToggleSuccess }) => {
  const [voteNumber, setVoteNumber] = useState("");
  const [errorVote, setErrorVote] = useState(false);
  const voteOfUser = useSelector((state) => state?.user?.voteOfUser || 0);
  const submitTimer = useRef();

  useEffect(() => {
    return () => {
      if (submitTimer.current) clearTimeout(submitTimer.current);
    };
  }, []);

  const handleSubmit = () => {

    if (submitTimer.current) clearTimeout(submitTimer.current);
    submitTimer.current = setTimeout(() => {
      if (errorVote) return;
      onSubmitVote(voteNumber || 0);
    }, 200);
    // setVoteNumber("")

  };

  const formatNumber = (value) => {
    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(".");
  };

  const checkInput = (e) => {

    const rawValue = e.target.value.replace(/\./g, "");
    const isNumber = /^\d*\.?\d*$/.test(rawValue);
    setVoteNumber(rawValue);

    if (!isNumber) {
      setErrorVote(true);
    } else {
      setErrorVote(false);
    }
  };

  return (
    <div className="p-[2vh]">
      <div className="items-center tracking-wide text-center" ref={submitTimer}>
        <strong className="text-[3vh] text-[#0ee2ff] uppercase">
          Bình chọn {isVoteSuccess ? " thành công" : ""}
        </strong>
        <div className="w-full font-medium text-[4vh] text-white uppercase font-gilroy">
          {data?.name}
        </div>
        {isVoteSuccess && (
          <div className="w-full pt-1 text-sm font-bold text-white uppercase md:mt-3 md:text-md">
            Cảm ơn bạn đã bình chọn cho thí sinh này!
          </div>
        )}
        {isVoteSuccess && <button
          onClick={()=> onToggleSuccess(false)}
          disabled={isLoading || voteOfUser === 0}
          className="justify-center disabled:opacity-30 disabled:cursor-not-allowed items-center h-[6vh] px-[4vh] my-[3vh] hover:opacity-80 transition !bg-gradient-to-t from-[#008cd5] to-[#0ee2ff] text-white mx-auto w-max rounded"
          type="button"
        >
          <span className="font-bold uppercase">{voteOfUser === 0 ? 'Hết lượt' : 'Tiếp tục'} bình chọn</span>
        </button>}

      </div>
      {!isVoteSuccess && (
        <form className="flex flex-col items-center">
          <div className="block w-full focus-visible:border-[#b036d0]">
            <span
              className="block text-center text-[3vh] text-white uppercase"
              htmlFor="voting-form"
            >
              Bạn còn
              <span className="font-medium font-gilroy text-[4vh]">
                {" "}
                {voteOfUser}{" "}
              </span>
              lượt Bình chọn
            </span>
            {/* <div className="mx-auto ">
              <input
                id="voting-form"
                autoComplete="off"
                onChange={checkInput}
                value={formatNumber(voteNumber)}
                type="text"
                maxLength={11}
                className="block w-full text-2xl font-normal text-center text-white bg-transparent border-b border-white h-11 lg:h-14 lg:text-3xl focus-visible:outline-none placeholder:text-lg"
                placeholder="Nhập dự đoán"
              />
            </div> */}
            {/* {errorVote ? (
              <span className="block text-sm text-red-600 lg:text-lg">
                Vui lòng chỉ nhập số
              </span>
            ) : null} */}
          </div>
          <div className="block w-full text-center">
            {/* <span className="block text-[2.5vh] mt-[2vh] font-light text-center text-white">
              Dự đoán số người bình chọn giống bạn để tham gia bốc thăm trúng
              các giải thưởng hấp dẫn
            </span> */}
            <button
              onClick={handleSubmit}
              disabled={isLoading || voteOfUser === 0}
              className="justify-center disabled:opacity-30 disabled:cursor-not-allowed items-center h-[6vh] px-[4vh] my-[3vh] hover:opacity-80 transition !bg-gradient-to-t from-[#008cd5] to-[#0ee2ff] text-white mx-auto w-max rounded "
              type="button"
            >
              {isLoading ? (
                <div className="flex items-center">
                  <svg
                    className="mr-2 text-white animate-spin h-7 w-7"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Đang xử lý...
                </div>
              ) : (
                <span className="font-bold uppercase ">GỬI BÌNH CHỌN</span>
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default FormVote;
